// Client contact roles — single source of truth (modals + upcoming All Contacts table bubbles).
// Only Primary Client Contact remains client-level. The six document-delivery roles (TBT, Invoice, Information
// Request, Authorizations, Budget, Refunds) moved to the property-scoped 'Contact Roles' lookup (category='delivery')
// so they can be assigned PER PROPERTY — see 2026-08-02_delivery_roles_to_property.sql.
export const CLIENT_CONTACT_ROLES = [
  { key: 'primary', label: 'Primary Client Contact', abbr: 'PRI' },
];
export const roleLabel = key => (CLIENT_CONTACT_ROLES.find(r => r.key === key) || {}).label || key;
export const roleAbbr  = key => (CLIENT_CONTACT_ROLES.find(r => r.key === key) || {}).abbr  || key;

// Consultant contact roles — separate pool (consultant_contacts / consultant_contact_roles).
export const CONSULTANT_CONTACT_ROLES = [
  { key: 'primary', label: 'Primary', abbr: 'PRI'  },
  { key: 'agent',   label: 'Agent',   abbr: 'AGT'  },
  { key: 'support', label: 'Support', abbr: 'SUPP' },
  { key: 'invoice', label: 'Invoice', abbr: 'INV'  },
  { key: 'attorney', label: 'Attorney', abbr: 'ATTY' },
];
export const consultantRoleLabel = key => (CONSULTANT_CONTACT_ROLES.find(r => r.key === key) || {}).label || key;
export const consultantRoleAbbr  = key => (CONSULTANT_CONTACT_ROLES.find(r => r.key === key) || {}).abbr  || key;

// Internal staff → client assignment roles (client_role_assignments.role). Distinct from the contact roles above:
// these are NTRG staff assigned to a client as Client Specialist / Tax Specialist / Client Manager.
export const CLIENT_ASSIGNMENT_ROLE = { CS: 'CS', TS: 'TS', CM: 'CM' };
export const CLIENT_ASSIGNMENT_ROLE_LABEL = { CS: 'Client Specialist', TS: 'Tax Specialist', CM: 'Client Manager' };
